/** Radix Select cannot hold an empty string, so "same as display value" needs a sentinel. */
export const SAME_AS_DISPLAY = '__same_as_display__';
